import type { HblPromoDetail } from '@/utils/types'

export function hblMapPromoDetail (promo: any): HblPromoDetail {
    return {
        id: promo.extensions?.promotion?.id,
        title: promo.customFields.lg_product_promotion_title ? promo.customFields.lg_product_promotion_title : promo.translated?.name,
        description: promo.customFields.lg_product_promotion_description,
        customFields: promo.translated?.customFields,
        media: promo.extensions?.promotion?.lg_product_promotion_image,
        validFrom: promo.extensions?.promotion?.validFrom,
        validUntil: promo.extensions?.promotion?.validUntil,
    }
}
